module.exports = __webpack_public_path__ + "img/coach.da463b5b.svg";